import i18n from 'i18next';

const PaymentMethodEnum = {
  ETC: 0,
  CARD: 1,
  LINEPAY: 2,
  PAYCO: 3,
  KAKAOPAY: 4,
  POINT: 7,
  properties: {
    0: i18n.t('payment.label.etc'),
    1: i18n.t('payment.label.card'),
    2: 'LINEPAY',
    3: '페이코',
    4: '카카오페이',
    7: i18n.t('payment.label.point'),
  },
};

export default PaymentMethodEnum;
